import { useLocation } from "wouter";
import { Navbar } from "@/components/landing/navbar";
import { HeroSection } from "@/components/landing/hero-section";
import { AppPreviewSection } from "@/components/landing/app-preview-section";
import { PricingSection } from "@/components/landing/pricing-section";
import { Footer } from "@/components/landing/footer";
import { useAuth } from "@/lib/auth";

export default function LandingPage() {
  const [, navigate] = useLocation();
  const { isAuthenticated } = useAuth();

  const handleStartRitual = () => {
    // If already logged in, go directly to plans
    if (isAuthenticated) {
      navigate("/plans");
    } else {
      navigate("/signup");
    }
  };

  const handleSelectPlan = (plan: "monthly" | "yearly") => {
    // Store selected plan and redirect appropriately
    sessionStorage.setItem("selectedPlan", plan);
    if (isAuthenticated) {
      navigate("/plans");
    } else {
      navigate("/signup");
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar onStartRitual={handleStartRitual} />
      
      <main>
        <HeroSection onStartRitual={handleStartRitual} />
        
        <AppPreviewSection />
        
        <div id="pricing">
          <PricingSection onSelectPlan={handleSelectPlan} />
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
